'use client';

import Button, { ButtonVariants } from '@pixum/button';
import { UploadErrorApplyForEveryXElements } from '../../UploadErrorApplyForEveryXElements';
import styles from './UploadErrorRemoveRetry.module.css';

interface UploadErrorRemoveRetryProps {
  errorCount: number;
  applyForAll: boolean;
  onApplyForAllChange: (checked: boolean) => void;
  onRemove: () => void;
  onRetry: () => void;
  constants: Record<string, string>;
}

export function UploadErrorRemoveRetry({
  errorCount,
  applyForAll,
  onApplyForAllChange,
  onRemove,
  onRetry,
  constants
}: UploadErrorRemoveRetryProps) {
  return (
    <div className={styles.uploadErrorRemoveRetry}>
      <div className={styles.uploadErrorRemoveRetryActions}>
        {errorCount > 1 && (
          <UploadErrorApplyForEveryXElements
            numOfErrors={errorCount}
            checked={applyForAll}
            constants={constants}
            onChange={onApplyForAllChange}
          />
        )}
        <Button variant={ButtonVariants.SECONDARY} onClick={onRemove}>
          {constants['i18n_remove_photo']}
        </Button>
        <Button onClick={onRetry}>{constants['i18n_upload_error_retry']}</Button>
      </div>
    </div>
  );
}
